import React, { useState, useEffect, useCallback } from "react";
import FormGenerator from "../../../../../../Components/FormGenerator";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  Divider,
  makeStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import UploadFilesComponent from "../../../../../../Components/FormGenerator/upload_files_component";
import {
  SetOrganisationDetails,
  UpdateOrganisationDetailsError,
} from "./OrganisationDetailsActions";
import AlertDialog from "../../../../../../Components/CustomDialog";

// const theme = createMuiTheme({
//   overrides: {
//     MuiFormControl: {
//       root: {
//         width: "100%",
//       },
//     },
//   },
// });

export const UploadFunction = (file) => {
  const temp = file;
  return temp;
};
export default function OrganisationDetails(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const {
    id,
    organisation_id,
    account_manager_id,
    coach_coordi_id,
    organisation_name,
    ownership_id,
    individual_types,
    type_of_organisation_id,
    type_of_services,
    services_offered = "",
    internal_status_id,
    territory_id,
    created_at,
    picture,
    industry_sector_lists,
    source_referral1_id,
    source_referral3_id,
    attended_acuity_event_date,
    level_structure,
    account_managers,
    coaching_coordinators,
    acuity_account_directors,
    picture1,
    client_account_management,
    panel,
    background,
    aimio_target_company,
    aimio_user,
    moe_target_company,
    moe_user,
    date_source_received,
    meeting_date,
    meeting_description,
    acuity_event,
    fully_managed_service,
    adhoc,
    meeting_details,
    client_action_lists,
    service_types: service_type_value,
    source_referral2s: source_referral2_value,
  } = useSelector((state) => state.organisationDetailsReducer.data);

  const {
    ownerships,
    individual_types: individual_type,
    type_of_organisations,
    service_types,
    // type_of_services,
    services_offereds,
    internal_statuses,
    territories,
    industry_sector_lists: industry_sector_list,
    source_referral1s,
    source_referral2s,
    source_referral3s,
    level_structures,
    client_account_managements,
    employees,
    who_by,
    priorities,
    org_areas,
    status,
    platforms,
    fully_managed_services,
    adhocs,
    // account_managers,
    // coaching_coordinators,
  } = useSelector((state) => state.commonReducer.organisationDropdowns);
  const reducerData = useSelector(
    (state) => state.organisationDetailsReducer.data
  );
  const typeOfServiceSelector = useSelector(
    (state) => state.commonReducer.organisationDropdowns.type_of_services
  );

  const accountManagerSelector = useSelector(
    (state) => state.commonReducer.organisationDropdowns.account_managers
  );
  const acuityAccountDrectorSelector = useSelector(
    (state) =>
      state.commonReducer.organisationDropdowns.acuity_account_directors
  );
  const coachingCoordinatorSelector = useSelector(
    (state) => state.commonReducer.organisationDropdowns.coaching_coordinators
  );
  const userRole = useSelector((state) => state.commonReducer.role);

  const errors = useSelector(
    (state) => state.organisationDetailsReducer.errors
  );

  const [loading, setLoading] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [dataArr, setDataArr] = useState([]);
  const [dataArr1, setDataArr1] = useState([]);
  const [checkBoxValue, setCheckBoxValue] = useState({});
  // useEffect(() => {
  //    setLoading(true);
  //    DataService.getDirectData(`/organisations/${id}`)
  //    .then((response) => {
  //      dispatch(UpdateOrganisationDetailsSectionId(id));
  //      dispatch(SetOrganisationDetails(response.data));
  //      dispatch(SetContactSectionAndOrgIds({sectionId: response.organisation_contact_info_id, organisationId: id}));
  //      dispatch(SetProfileSectionAndOrgIds({sectionId: response.organisation_profile_id, organisationId: id}));
  //      dispatch(SetGeneralSectionAndOrgIds({sectionId: response.organisation_general_detail_id, organisationId: id}));
  //      dispatch(SetPreContractSectionAndOrgIds({sectionId: response.organisation_pre_contract_id, organisationId: id}));
  //      dispatch(SetOrganisationContractSectionAndOrgIds({sectionId: response.organisation_contract_phase_id, organisationId: id}));
  //      dispatch(SetOrganisationActivitySectionAndOrgIds({sectionId: response.organisation_activity_field_id, organisationId: id}));
  //      setLoading(false);
  //    })
  //    .catch((err) => {});
  // }, [errors]);

  const handleInputChange = (value, index, selectValue, key) => {
    props.setSomeChangeDetected(true);
    if (value === "removeDate") {
      const updatedForm = [...formInput];
      const formData = {};
      updatedForm.forEach((item) => {
        if (
          item.name === "attended_acuity_event_date" &&
          selectValue === "Yes"
        ) {
          formData[item.name] = item.value ?? "";
          dispatch(SetOrganisationDetails(formData));
        } else if (
          item.name === "attended_acuity_event_date" &&
          selectValue === "No"
        ) {
          updatedForm[item.name] = "";
          setFormInput(updatedForm);
          formData[item.name] = "";
          dispatch(SetOrganisationDetails(formData));
        }
      });
    } else {
      let updatedForm = formInput;
      let keyIndex = index;
      if (key) {
        keyIndex = formInput.findIndex((item) => item.name === key);
        updatedForm[keyIndex]["value"] = value;
      } else {
        updatedForm[keyIndex]["value"] = value;
      }
      setFormInput(updatedForm);
      const formData = {};
      formInput.forEach((item, fIndex) => {
        if (fIndex === keyIndex) {
          formData[item.name] = item.value ?? "";
          dispatch(SetOrganisationDetails(formData));
        }
      });
      dispatch(UpdateOrganisationDetailsError(updatedForm[keyIndex].name));
    }
  };

  const handleCheckboxValue = (event) => {
    setCheckBoxValue({
      ...checkBoxValue,
      [event.target.name]: event.target.checked,
    });
  };

  const [emptyError, setEmptyError] = useState(null);
  const [previewImage, setPreviewImage] = useState("");
  const [imageSize, setImageSize] = useState("");
  const handleUploadChange = (event, setData, setUploadData) => {
    // var localArr = [];
    // var pdata = {
    //   // attributes: {
    //     document: event.target.files[0],
    //     // created_at: "2021-04-08T12:06:08.000Z",
    //     file_name: event.target.files[0].name,
    //   // },
    // };
    // localArr.push(pdata);
    // setData( data.concat(localArr));
    // setUploadData(uploadData.concat(localArr))
    if (event.target.files && event.target.files[0]) {
      setImageSize(event.target.files[0].size);
      // console.log('event.target.files', event.target.files[0].size)
      let reader = new FileReader();
      reader.onload = (e) => {
        setData(e.target.result);
        setUploadData(e.target.result);
        // console.log(`object`, object)
        setEmptyError(null);
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    // UploadFunction(dataArr)
  };
  // const handleUploadChange1 = (event, id) => {
  //   var localArr1 = [];
  //   var pdata1 = {
  //     // attributes: {
  //       document: event.target.files[0],
  //       // created_at: "2021-04-08T12:06:08.000Z",
  //       file_name: event.target.files[0].name,
  //     // },
  //   };
  //   localArr1.push(pdata1);
  //   setDataArr1( dataArr1.concat(localArr1));
  //   props.setOrgUpload1(props.orgUpload1.concat(localArr1))
  //   // UploadFunction(dataArr)
  // };
  const OnlyAcuityArray = [
    "organisation_name",
    "level_structure",
    "service_types",
    "services_offered",
    "territory_id",
    "industry_sector_lists",
    "acuity_account_directors",
    "coaching_coordinators",
    "account_managers",
  ];

  const formArray = [
    {
      componentType: "input",
      type: "text",
      label: "Organization name*",
      autoFocus: true,
      helperText:
        errors && errors.organisation_name && "Please enter Organisation Name",
      name: "organisation_name",
      value: organisation_name,
      placeholder: "Organization name",
      handleChange: handleInputChange,
    },
    {
      componentType: "select",
      label: "Level structure",
      // helperText:
      //   errors && errors.level_structure && "Please enter Level Structure",
      name: "level_structure",
      value: level_structure,
      placeholder: "Select level structure",
      selectOptions: level_structures,
      // selectOptions: [{id: 0, value: 'Client', name: 'Client'},{id: 1, value: 'Partner', name: 'Partner'},{id: 2, value: 'Supplier', name: 'Supplier'},{id: 3, value: 'Internal Suppliers', name:'Internal Suppliers'},{id: 4, value: 'Competitor', name: 'Competitor'}],
      handleChange: handleInputChange,
    },
    {
      componentType: "SelectSpecific",
      label: "Ownership",
      name: "ownership_id",
      id: "ownership_id",
      value: ownership_id,
      placeholder: "Select ownership",
      selectOptions: ownerships,
      handleChange: handleInputChange,
      dropDown: "Ownership",
      field_name: "ownership",
    },
    {
      componentType: "multiSelectChip",
      label: "Organizational type*",
      name: "individual_types",
      value: individual_types,
      placeholder: "Organizational type",
      id: "individual_types",
      required: true,
      itemArr: individual_type,
      handleChange: handleInputChange,
      helperText:
        errors &&
        errors.individual_types &&
        "Please select the Organizational Type",
      dropDown: "IndividualType",
      field_name: "individual_type",
    },
    {
      componentType: "input",
      type: "text",
      label: "Background/Overview",
      name: "background",
      multiline: true,
      placeholder: "Background/Overview",
      handleChange: handleInputChange,
      value: background,
    },
    {
      componentType: "multiSelectChip",
      label: "Type of contract",
      name: "fully_managed_service",
      value: fully_managed_service,
      id: "fully_managed_service",
      required: true,
      placeholder: "Select type of contract",
      itemArr: fully_managed_services,
      handleChange: handleInputChange,
      dropDown: "FullyManagedService",
      field_name: "name",
    },
    {
      componentType: "multiSelectChip",
      label: "Contract category",
      name: "adhoc",
      value: adhoc,
      id: "adhoc",
      required: true,
      placeholder: "Select contract category",
      itemArr: adhocs,
      handleChange: handleInputChange,
      dropDown: "Adhoc",
      field_name: "name",
    },
    {
      componentType: "multiSelectChip",
      label: "Service",
      name: "service_types",
      value: service_type_value,
      placeholder: "Service",
      // apiVariable: "type_of_services",
      selectOptions: service_types,
      itemArr: service_types,
      handleChange: handleInputChange,
      // dropDown: "TypeOfService",
      // field_name: "type_of_service",
    },
    {
      componentType: "multiSelectChip",
      label: "Service type",
      name: "type_of_services",
      value: type_of_services,
      placeholder: "Service type",
      // apiVariable: "type_of_services",
      itemArr: typeOfServiceSelector,
      selectOptions: typeOfServiceSelector,
      handleChange: handleInputChange,
      dropDown: "TypeOfService",
      field_name: "type_of_service",
    },
    {
      componentType: "input",
      label: "Services offered",
      name: "services_offered",
      value: services_offered?.length ? services_offered.join("\n") : "",
      multiline: true,
      disabled: true,
      // id: "services_offered",
      // placeholder: "Services offered",
      // itemArr: services_offereds,

      handleChange: handleInputChange,
    },
    {
      componentType: "SelectSpecific",
      label: "Internal status*",
      name: "internal_status_id",
      id: "internal_status_id",
      helperText:
        errors &&
        errors.internal_status_id &&
        "Please select the Internal Status",
      value: internal_status_id,
      placeholder: "Internal status",
      // apiVariable: "internal_status",
      selectOptions: internal_statuses,
      handleChange: handleInputChange,
      dropDown: "InternalStatus",
      field_name: "internal_status",
    },
    {
      componentType: "select",
      label: (
        <span>
          <strong>aimio</strong> target company
        </span>
      ),
      name: "aimio_target_company",
      value: aimio_target_company,
      placeholder: "Select yes or no",
      selectOptions: [
        { id: "Yes", value: "Yes", name: "yes" },
        { id: "No", value: "No", name: "No" },
        { id: "Not known yet", value: "Not known yet", name: "Not known yet" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "select",
      label: (
        <span>
          <strong>aimio</strong> user
        </span>
      ),
      name: "aimio_user",
      value: aimio_user,
      placeholder: "Select yes or no",
      selectOptions: [
        { id: "Yes", value: "Yes", name: "yes" },
        { id: "No", value: "No", name: "No" },
        { id: "Not known yet", value: "Not known yet", name: "Not known yet" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "select",
      label: "MOE target company",
      name: "moe_target_company",
      value: moe_target_company,
      placeholder: "Select yes or no",
      selectOptions: [
        { id: "Yes", value: "Yes", name: "yes" },
        { id: "No", value: "No", name: "No" },
        { id: "Not known yet", value: "Not known yet", name: "Not known yet" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "select",
      label: "MOE user",
      name: "moe_user",
      value: moe_user,
      Question: "Yes/NO",
      placeholder: "Select yes or no",
      selectOptions: [
        { id: "Yes", value: "Yes", name: "yes" },
        { id: "No", value: "No", name: "No" },
        { id: "Not known yet", value: "Not known yet", name: "Not known yet" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "SelectSpecific",
      label: "Territory*",
      name: "territory_id",
      id: "territory_id",
      helperText:
        errors && errors.territory_id && "Please select the Territory",
      value: territory_id,
      placeholder: "Territory",
      // apiVariable: "territories",
      selectOptions: territories,
      handleChange: handleInputChange,
      dropDown: "Territory",
      field_name: "territory",
    },
    {
      componentType: "multiSelectChip",
      label: "Industry sector*",
      name: "industry_sector_lists",
      value: industry_sector_lists,
      id: "industry_sector_lists",
      required: true,
      placeholder: "Industry sector",
      itemArr: industry_sector_list,
      helperText:
        errors &&
        errors.industry_sector_lists &&
        "Please enter Industry Sector",
      handleChange: handleInputChange,
      dropDown: "IndustrySectorList",
      field_name: "industry_sector",
    },
    {
      componentType: "SelectSpecific",
      label: "Source type*",
      id: "source_referral1_id",
      name: "source_referral1_id",
      value: source_referral1_id,
      placeholder: "Source type",
      select: true,
      defaultValue: "Select Ownership",
      // apiVariable: "source_referral1",
      selectOptions: source_referral1s,
      handleChange: handleInputChange,
      dropDown: "SourceReferral1",
      field_name: "referral1",
      helperText:
        errors && errors.source_referral1_id && "Please select a source type",
    },
    {
      // componentType: "SelectSpecific",
      // label: "Source company*",
      // name: "source_referral2_id",
      // value: source_referral2_id,
      // placeholder: "Source company",
      // // apiVariable: "source_referral2",
      // selectOptions: source_referral2s,
      // handleChange: handleInputChange,
      // dropDown: "SourceReferral2",
      // field_name: "referral2",
      // helperText:
      //   errors &&
      //   errors.source_referral2_id &&
      //   "Please select a source company",

      componentType: "multiSelectChip",
      label: "Source company*",
      name: "source_referral2s",
      value: source_referral2_value,
      id: "source_referral2_id",
      placeholder: "Source company",
      selectOptions: source_referral2s,
      itemArr: source_referral2s,
      handleChange: handleInputChange,
      dropDown: "SourceReferral2",
      field_name: "referral2",
      helperText:
        errors && errors.source_referral2s && "Please select a source company",
    },
    {
      componentType: "SelectSpecific",
      label: "Source person*",
      id: "source_referral3_id",
      name: "source_referral3_id",
      value: source_referral3_id,
      placeholder: "Source person",
      // apiVariable: "source_referral3",
      selectOptions: source_referral3s,
      handleChange: handleInputChange,
      dropDown: "SourceReferral3",
      field_name: "referral3",
      helperText:
        errors && errors.source_referral3_id && "Please select a source person",
    },
    {
      componentType: "datePicker",
      required: true,
      label: "Date source received*",
      name: "date_source_received",
      value: date_source_received,
      futureDateHide: true,
      handleChange: handleInputChange,
      helperText:
        errors && errors.date_source_received && "Please enter a Date",
    },
    {
      componentType: "selectWithDatePicker",
      label: "Attended Acuity event/s",
      name: "attended_acuity_event_date",
      value: attended_acuity_event_date,
      placeholder: "Attended Acuity event/s",
      selectOptions: [
        { id: "Yes", value: "Yes", name: "Yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      type: "text",
      multiline: true,
      label: "Acuity event",
      // helperText:
      //   errors && errors.acuity_event && "Please enter Acuity Event",
      name: "acuity_event",
      value: acuity_event,
      placeholder: "Acuity event",
      handleChange: handleInputChange,
    },
    {
      componentType: "select",
      label: "Panel",
      name: "panel",
      value: panel,
      placeholder: "Select yes or no",
      selectOptions: [
        { id: "Yes", value: "Yes", name: "yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "imageUploadWithCrop",
      label: "Organization picture",
      // errorMsg: ".png, .jpg",
      existingImage: props.existingImage || null,
      setImageBlob: props.setImageBlob,
      section: "org",
      cropProps: { unit: "%", width: 45, height: 40 },
      previewStyle: {
        // width: "100%",
        width: "250px",
        height: "250px",
        borderRadius: 0,
      },
      imgPreviewProps: {
        // width: "100%",
        width: "250px",
        height: "250px",
        style: {
          borderRadius: 0,
          objectFit: "cover",
          width: "250px",
        },
      },
    },
    {
      componentType: "multiSelectChip",
      label: "Acuity account director",
      name: "acuity_account_directors",
      value: acuity_account_directors,
      id: "acuity_account_directors",
      placeholder: "Acuity account director",
      itemArr: acuityAccountDrectorSelector,
      handleChange: handleInputChange,
    },
    {
      componentType: "multiSelectChip",
      label: "Acuity account manager",
      name: "account_managers",
      // value: account_manager_id,
      placeholder: "Acuity account manager",
      itemArr: accountManagerSelector,
      id: "account_managers",
      value: account_managers,
      handleChange: handleInputChange,
    },
    {
      componentType: "multiSelectChip",
      label: "Acuity coaching coordinator",
      name: "coaching_coordinators",
      value: coaching_coordinators,
      id: "coaching_coordinators",
      placeholder: "Acuity coaching coordinator",
      itemArr: coachingCoordinatorSelector,
      selectOptions: coaching_coordinators,
      handleChange: handleInputChange,
    },
    {
      componentType: "SelectSpecific",
      label: "Client account management",
      id: "client_account_management",
      name: "client_account_management",
      value: client_account_management,
      placeholder: "Select client account management",
      selectOptions: client_account_managements,
      handleChange: handleInputChange,
      dropDown: "ClientAccountManagement",
      field_name: "client_account_management",
    },
    {
      label: "Meeting/Call documents",
      componentType: "uploadFiles",
      name: "meeting_documents",
      buttonLabel: "Document upload",
      handleChange: handleInputChange,
      labelStyle: {},
    },
    {
      componentType: "rederComponent",
      name: "meeting_details",
      value: meeting_details,
      label: "Meeting/Call dates",
      component: (
        <MeetingDetailsComponent
          handleChange={handleInputChange}
          name="meeting_details"
          value={meeting_details}
          label="Meeting/Call dates"
          componentObject={[
            {
              componentType: "datePicker",
              type: "text",
              label: "Meeting date",
              name: "meeting_datetime",
            },
            {
              componentType: "timeComponent",
              type: "text",
              label: "Meeting start time",
              name: "start_time",
            },
            {
              componentType: "timeComponent",
              type: "text",
              label: "Meeting end time",
              name: "end_time",
            },
            {
              componentType: "input",
              type: "text",
              label: "Description of call",
              name: "description",
              placeholder: "Description of call",
              multiline: true,
            },
            {
              componentType: "input",
              type: "text",
              label: "Who involved in meeting",
              name: "who_involved",
              placeholder: "Who involved in meeting",
              multiline: true,
            },
            {
              componentType: "input",
              type: "text",
              label: "Prep required",
              name: "prep_required",
              placeholder: "Prep required",
              multiline: true,
            },
            {
              componentType: "input",
              type: "text",
              label: "Temporary owner",
              name: "temporary_owner",
              placeholder: "Temporary owner",
              multiline: true,
            },
            {
              componentType: "select",
              label: "Platform",
              name: "platform",
              placeholder: "Platform",
              selectOptions: platforms,
              handleChange: handleInputChange,
            },
            {
              componentType: "input",
              type: "text",
              label: "Briefing",
              name: "briefing",
              placeholder: "Briefing",
              multiline: true,
            },
          ]}
        />
      ),
    },
    {
      componentType: "rederComponent",
      name: "client_action_lists",
      value: client_action_lists,
      component: (
        <ClientActionListComponent
          handleChange={handleInputChange}
          name="client_action_lists"
          value={client_action_lists}
          label="Client action list"
          componentObject={[
            {
              componentType: "datePicker",
              type: "text",
              label: "Date received",
              name: "date_received",
            },
            {
              componentType: "select",
              label: "Priority",
              name: "priority_id",
              placeholder: "Priority",
              selectOptions: priorities,
              handleChange: handleInputChange,
            },
            {
              componentType: "select",
              label: "Status",
              name: "status",
              placeholder: "Status",
              selectOptions: status,
              handleChange: handleInputChange,
            },
            {
              componentType: "SelectSpecific",
              label: "Area",
              id: "org_area_id",
              name: "org_area_id",
              placeholder: "Area",
              isChild: true,
              selectOptions: org_areas,
              handleChange: handleInputChange,
              dropDown: "OrgArea",
              field_name: "name",
            },
            {
              componentType: "input",
              type: "text",
              label: "Description",
              name: "description",
              placeholder: "Description",
              multiline: true,
            },
            {
              componentType: "input",
              type: "text",
              label: "Stakeholder/s",
              name: "stakeholders",
              placeholder: "Stakeholders",
              multiline: true,
            },
            {
              componentType: "multiSelectChip",
              label: "Who by",
              name: "who_by",
              id: "who_by",
              placeholder: "Who by",
              itemArr: who_by,
              isChild: true,
            },
            {
              componentType: "datePicker",
              type: "text",
              label: "Deadline date",
              name: "deadline_date",
            },
            {
              componentType: "datePicker",
              type: "text",
              label: "Completed date",
              name: "completed_date",
            },
          ]}
        />
      ),
    },
  ];

  const newArray =
    userRole !== "admin"
      ? formArray.filter((array) => OnlyAcuityArray.includes(array.name))
      : formArray;

  const [formInput, setFormInput] = useState(newArray);

  useEffect(() => {
    setFormInput(newArray);
  }, [
    errors,
    // meeting_details,
    // organisation_name,
    ownerships?.length,
    individual_type?.length,
    typeOfServiceSelector?.length,
    internal_statuses?.length,
    territories?.length,
    industry_sector_list?.length,
    source_referral1s?.length,
    source_referral2s?.length,
    source_referral3s?.length,
    org_areas?.length,
    fully_managed_services?.length,
    adhocs?.length,
    props.existingImage,
    reducerData,
  ]);

  return (
    <FormGenerator
      children={formInput}
      nextIndex={1}
      moduleName="organization"
      // setId={props.setId}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      display: "flex",
    },
  },
  gridRoot: {
    flexGrow: 1,
    marginBottom: "20px",
  },
  helperText: {
    color: "red",
  },
  disabled: {
    background: "#f5f2f2",
  },
  textInput: {
    "& input::placeholder": {
      color: "#808080",
      opacity: 1,
    },
  },
  meetingItems: {
    display: "flex",
    alignItems: "baseline",
    paddingBottom: "10px",
  },
  accordionWrapper: {
    flexGrow: 1,
    border: "1px solid #ccc",
    borderBottom: "0",
    "& > div": {
      minHeight: "0px !important",
    },
    "& > div > div:first-child": {
      minHeight: "0px !important",
      margin: 0,
    },
  },
  accordionTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
}));

const MeetingDetailsComponent = (props) => {
  const classes = useStyles();
  const { name, handleChange, label } = props;
  const [callMeetingItem, setCallMeetingItem] = useState([]);

  const [formInput, setFormInput] = useState(props?.componentObject);
  const [dialogState, setDialogState] = useState(undefined);
  const [dialogStateActions, setDialogStateActions] = useState(undefined);
  const { meeting_details } = useSelector(
    (state) => state.organisationDetailsReducer.data
  );

  const handleInputChange = useCallback(
    (value, index, type, perentIndex) => {
      setCallMeetingItem((prevState) => {
        const keyIndex = [
          "meeting_datetime",
          "start_time",
          "end_time",
          "description",
          "who_involved",
          "prep_required",
          "temporary_owner",
          "platform",
          "briefing",
        ];
        prevState[perentIndex] = { ...prevState[perentIndex] };
        prevState[perentIndex][keyIndex[index]] = value;
        return [...prevState];
      });
      callMeetingItem?.length && handleChange(callMeetingItem, 0, "", name);
    },
    [callMeetingItem]
  );

  useEffect(() => {
    meeting_details?.length && setCallMeetingItem(meeting_details);
  }, [meeting_details]);

  useEffect(() => {
    props?.componentObject?.length &&
      setFormInput((oldValue) => [
        ...oldValue.map((item, index) => ({
          ...item,
          handleChange: handleInputChange,
          formGeneratorPerentIndex: index,
        })),
      ]);
  }, [props?.componentObject?.length]);

  const handleMeeting = (isAdd, index) => {
    if (isAdd) {
      const newCall = {
        meeting_datetime: "",
        start_time: "",
        end_time: "",
        description: "",
        who_involved: "",
        prep_required: "",
        temporary_owner: "",
        platform: [],
        briefing: "",
        expanded: true,
      };
      const newItem = [
        ...callMeetingItem.map((item) => ({ ...item, expanded: false })),
        ...[newCall],
      ];
      setCallMeetingItem(newItem);
      handleChange(newItem, 0, "", name);
    } else {
      callMeetingItem.splice(index, 1);
      callMeetingItem.map((item) => ({ ...item, expanded: false }));
      handleChange(callMeetingItem, 0, "", name);
      setCallMeetingItem([...callMeetingItem]);
    }
  };

  const handleChild = (isAdd, index, parentIndex) => {
    if (isAdd) {
      const newCall = {
        deadline_date: "",
        description: "",
        who: "",
        completed: false,
      };
      let updatedData = { ...callMeetingItem[parentIndex] };
      if (updatedData["detail_of_actions"]?.length) {
        updatedData["detail_of_actions"] = [
          ...updatedData["detail_of_actions"],
          ...[newCall],
        ];
      } else {
        updatedData["detail_of_actions"] = [newCall];
      }
      callMeetingItem[parentIndex] = { ...updatedData };
      setCallMeetingItem(callMeetingItem);
      handleChange(callMeetingItem, parentIndex, "", name);
    } else {
      callMeetingItem[parentIndex]["detail_of_actions"].splice(index, 1);
      handleChange(callMeetingItem, 0, "", name);
      setCallMeetingItem([...callMeetingItem]);
    }
  };

  const handleChildInputChange = useCallback(
    (value, index, type, parentIndex) => {
      const ParentIndexIds = parentIndex.split("-");
      setCallMeetingItem((prevState) => {
        const keyIndex = ["deadline_date", "description", "who", "completed"];
        const meetingItem = { ...prevState[ParentIndexIds[0]] };
        meetingItem["detail_of_actions"][ParentIndexIds[1]][keyIndex[index]] =
          value;
        prevState[ParentIndexIds[0]] = { ...meetingItem };
        return [...prevState];
      });
      callMeetingItem?.length &&
        handleChange(callMeetingItem, ParentIndexIds[0], "", name);
    },
    [callMeetingItem]
  );

  const formArray = [
    {
      componentType: "datePicker",
      type: "text",
      label: "Deadline date",
      name: "deadline_date",
      handleChange: handleChildInputChange,
    },
    {
      componentType: "input",
      type: "text",
      label: "Description",
      name: "description",
      placeholder: "Description",
      multiline: true,
      handleChange: handleChildInputChange,
    },
    {
      componentType: "input",
      type: "text",
      label: "Who",
      name: "who",
      placeholder: "Who",
      multiline: true,
      handleChange: handleChildInputChange,
    },
    {
      componentType: "singleCheckbox",
      label: "Completed",
      value: false,
      name: "completed",
      onChange: handleChildInputChange,
    },
  ];

  useEffect(() => {
    formArray?.length &&
      setFormInput((oldValue) => [
        ...oldValue.map((item, index) => ({
          ...item,
          handleChange: handleChildInputChange,
          formGeneratorPerentIndex: index,
        })),
      ]);
  }, [formArray?.length]);

  const handleCollapse = (index) => {
    setCallMeetingItem((oldValue) => [
      ...oldValue.map((item, itemIndex) => {
        if (itemIndex === index)
          return { ...item, expanded: item?.expanded ? !item.expanded : true };
        else return { ...item, expanded: false };
      }),
    ]);
  };

  return (
    <Grid container className={classes.gridRoot}>
      <Grid item xs={12} md={4}>
        <Grid xs={12}>{label}</Grid>
      </Grid>
      <Grid item xs={12} md={7}>
        {callMeetingItem?.map((item, index) => {
          const formInputFields =
            props?.componentObject?.length &&
            props?.componentObject.map((fieldItem) => ({
              ...fieldItem,
              handleChange: handleInputChange,
              value: item[fieldItem.name],
            }));
          return (
            <div className={classes.meetingItems}>
              <Accordion
                className={classes.accordionWrapper}
                expanded={item?.expanded}
                onChange={(e) => {
                  handleCollapse(index);
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.accordionTitle}>
                    Meeting/Call dates #{index + 1}
                    <AddCircleIcon
                      type="submit"
                      onClick={(e) => {
                        e.stopPropagation();
                        setDialogState({
                          isOpen: true,
                          index,
                        });
                      }}
                      fontSize="large"
                      color="error"
                      style={{ cursor: "pointer", transform: "rotate(45deg)" }}
                    />
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid item xs={12}>
                    <FormGenerator
                      pIndex={index}
                      children={formInputFields}
                      handleNext={props.handleNext}
                      nextIndex={6}
                      setId={props.setId}
                      style={
                        {
                          // width: "100%",
                        }
                      }
                    />
                    <Grid container>
                      <Grid item xs={12} md={4}>
                        Detail of action
                      </Grid>
                      <Grid item xs={12} md={8}>
                        {item?.detail_of_actions?.length
                          ? item?.detail_of_actions?.map(
                              (childItem, childIndex) => {
                                const formInputFields =
                                  formArray?.length &&
                                  formArray.map((fieldItem) => ({
                                    ...fieldItem,
                                    handleChange: handleChildInputChange,
                                    value: childItem[fieldItem.name],
                                  }));
                                return (
                                  <>
                                    <Grid container>
                                      <Grid item xs={11}>
                                        <FormGenerator
                                          pIndex={`${index}-${childIndex}`}
                                          children={formInputFields}
                                          handleNext={props.handleNext}
                                          nextIndex={6}
                                          setId={props.setId}
                                          style={
                                            {
                                              // width: "100%",
                                            }
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={1}>
                                        <AddCircleIcon
                                          type="submit"
                                          onClick={() =>
                                            setDialogStateActions({
                                              isOpen: true,
                                              index,
                                              childIndex,
                                            })
                                          }
                                          fontSize="large"
                                          color="error"
                                          style={{
                                            cursor: "pointer",
                                            transform: "rotate(45deg)",
                                          }}
                                        />
                                      </Grid>
                                    </Grid>
                                    <Divider style={{ marginBottom: "20px" }} />
                                  </>
                                );
                              }
                            )
                          : null}
                        <AddCircleIcon
                          type="submit"
                          onClick={() => handleChild(true, 0, index)}
                          fontSize="large"
                          color="primary"
                          style={{ cursor: "pointer" }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </div>
          );
        })}
        <div style={{ display: "flex", alignItems: "center" }}>
          <AddCircleIcon
            type="submit"
            onClick={() => handleMeeting(true, 0)}
            fontSize="large"
            color="primary"
            style={{ cursor: "pointer" }}
          />
        </div>
      </Grid>
      {dialogState?.isOpen && (
        <AlertDialog
          dialogState={dialogState}
          dialogContent={`Are you sure you want to delete this meeting details?`}
          handleSubmit={(value) => handleMeeting(false, value?.index)}
          handleClose={() => setDialogState(undefined)}
        />
      )}
      {dialogStateActions?.isOpen && (
        <AlertDialog
          dialogState={dialogStateActions}
          dialogContent={`Are you sure you want to delete this detail of action?`}
          handleSubmit={(value) =>
            handleChild(false, value?.childIndex, value?.index)
          }
          handleClose={() => setDialogStateActions(undefined)}
        />
      )}
    </Grid>
  );
};

const ClientActionListComponent = (props) => {
  const classes = useStyles();
  const { name, handleChange, label } = props;
  const [clientActionItem, setClientActionItem] = useState([]);
  const [dialogState, setDialogState] = useState(undefined);
  const [dialogStateActions, setDialogStateActions] = useState(undefined);
  const [formInput, setFormInput] = useState(props?.componentObject);
  const { client_action_lists } = useSelector(
    (state) => state.organisationDetailsReducer.data
  );

  const handleInputChange = useCallback(
    (value, index, type, perentIndex) => {
      setClientActionItem((prevState) => {
        const keyIndex = [
          "date_received",
          "priority_id",
          "status",
          "org_area_id",
          "description",
          "stakeholders",
          "who_by",
          "deadline_date",
          "completed_date",
          "follow_up_date",
          "completed_follow_up_date",
        ];
        prevState[perentIndex] = { ...prevState[perentIndex] };
        prevState[perentIndex][keyIndex[index]] = value;
        return [...prevState];
      });
      clientActionItem?.length && handleChange(clientActionItem, 0, "", name);
    },
    [clientActionItem]
  );

  useEffect(() => {
    client_action_lists?.length && setClientActionItem(client_action_lists);
  }, [client_action_lists]);

  useEffect(() => {
    props?.componentObject?.length &&
      setFormInput((oldValue) => [
        ...oldValue.map((item, index) => ({
          ...item,
          handleChange: handleInputChange,
          formGeneratorPerentIndex: index,
        })),
      ]);
  }, [props?.componentObject?.length]);

  const handleClientAction = (isAdd, index) => {
    if (isAdd) {
      const newCall = {
        date_received: "",
        priority_id: "",
        status: "",
        org_area_id: 0,
        description: "",
        stakeholders: "",
        who_by: [],
        deadline_date: "",
        completed_date: "",
        expanded: true,
      };
      const newItem = [
        ...clientActionItem.map((item) => ({ ...item, expanded: false })),
        ...[newCall],
      ];
      setClientActionItem(newItem);
      handleChange(newItem, 0, "", name);
    } else {
      clientActionItem.splice(index, 1);
      clientActionItem.map((item) => ({ ...item, expanded: false }));
      handleChange(clientActionItem, 0, "", name);
      setClientActionItem([...clientActionItem]);
    }
  };

  const handleChild = (isAdd, index, parentIndex) => {
    if (isAdd) {
      const newCall = {
        follow_up_date: "",
        completed_follow_up_date: "",
      };
      let updatedData = { ...clientActionItem[parentIndex] };
      if (updatedData["follow_up_schedule"]?.length) {
        updatedData["follow_up_schedule"] = [
          ...updatedData["follow_up_schedule"],
          ...[newCall],
        ];
      } else {
        updatedData["follow_up_schedule"] = [newCall];
      }
      clientActionItem[parentIndex] = { ...updatedData };
      setClientActionItem(clientActionItem);
      handleChange(clientActionItem, parentIndex, "", name);
    } else {
      clientActionItem[parentIndex]["follow_up_schedule"].splice(index, 1);
      handleChange(clientActionItem, 0, "", name);
      setClientActionItem([...clientActionItem]);
    }
  };

  const handleChildInputChange = useCallback(
    (value, index, type, parentIndex) => {
      const ParentIndexIds = parentIndex.split("-");
      setClientActionItem((prevState) => {
        const keyIndex = ["follow_up_date", "completed_follow_up_date"];
        const meetingItem = { ...prevState[ParentIndexIds[0]] };
        meetingItem["follow_up_schedule"][ParentIndexIds[1]][keyIndex[index]] =
          value;
        prevState[ParentIndexIds[0]] = { ...meetingItem };
        return [...prevState];
      });
      clientActionItem?.length &&
        handleChange(clientActionItem, ParentIndexIds[0], "", name);
    },
    [clientActionItem]
  );

  const formArray = [
    {
      componentType: "datePicker",
      type: "text",
      label: "Follow up date",
      name: "follow_up_date",
      handleChange: handleChildInputChange,
    },
    {
      componentType: "datePicker",
      type: "text",
      label: "Completed follow up date",
      name: "completed_follow_up_date",
      handleChange: handleChildInputChange,
    },
  ];

  useEffect(() => {
    formArray?.length &&
      setFormInput((oldValue) => [
        ...oldValue.map((item, index) => ({
          ...item,
          handleChange: handleChildInputChange,
          formGeneratorPerentIndex: index,
        })),
      ]);
  }, [formArray?.length]);

  // useEffect(() => {
  //   props?.setSomeChangeDetected(false);
  // }, [])

  const handleCollapse = (index) => {
    setClientActionItem((oldValue) => [
      ...oldValue.map((item, itemIndex) => {
        if (itemIndex === index)
          return { ...item, expanded: item?.expanded ? !item.expanded : true };
        else return { ...item, expanded: false };
      }),
    ]);
  };

  return (
    <Grid container className={classes.gridRoot}>
      <Grid item xs={12} md={4}>
        {label}
      </Grid>
      <Grid item xs={12} md={7} style={{ marginTop: "-11px" }}>
        {clientActionItem?.map((item, index) => {
          const formInputFields =
            props?.componentObject?.length &&
            props?.componentObject.map((fieldItem) => ({
              ...fieldItem,
              handleChange: handleInputChange,
              value: item[fieldItem.name],
            }));
          return (
            <div className={classes.meetingItems}>
              <Accordion
                className={classes.accordionWrapper}
                expanded={item?.expanded}
                onChange={(e) => {
                  e.stopPropagation();
                  handleCollapse(index);
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.accordionTitle}>
                    {label} #{index + 1}
                    <AddCircleIcon
                      type="submit"
                      onClick={(e) => {
                        e.stopPropagation();
                        setDialogState({
                          isOpen: true,
                          index,
                        });
                      }}
                      fontSize="large"
                      color="error"
                      style={{ cursor: "pointer", transform: "rotate(45deg)" }}
                    />
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid item xs={12}>
                    <FormGenerator
                      pIndex={index}
                      children={formInputFields}
                      handleNext={props.handleNext}
                      nextIndex={6}
                      setId={props.setId}
                      moduleName="organization"
                      style={
                        {
                          // width: "100%",
                        }
                      }
                    />
                    <Grid container>
                      <Grid item xs={12} md={4}>
                        Follow up schedule
                      </Grid>
                      <Grid item xs={12} md={8}>
                        {item?.follow_up_schedule?.length
                          ? item?.follow_up_schedule?.map(
                              (childItem, childIndex) => {
                                const formInputFields =
                                  formArray?.length &&
                                  formArray.map((fieldItem) => ({
                                    ...fieldItem,
                                    handleChange: handleChildInputChange,
                                    value: childItem[fieldItem.name],
                                  }));
                                return (
                                  <>
                                    <Grid container>
                                      <Grid item xs={11}>
                                        <FormGenerator
                                          pIndex={`${index}-${childIndex}`}
                                          children={formInputFields}
                                          handleNext={props.handleNext}
                                          nextIndex={6}
                                          setId={props.setId}
                                          style={
                                            {
                                              // width: "100%",
                                            }
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={1}>
                                        <AddCircleIcon
                                          type="submit"
                                          onClick={() =>
                                            setDialogStateActions({
                                              isOpen: true,
                                              childIndex,
                                              index,
                                            })
                                          }
                                          fontSize="large"
                                          color="error"
                                          style={{
                                            cursor: "pointer",
                                            transform: "rotate(45deg)",
                                          }}
                                        />
                                      </Grid>
                                    </Grid>
                                    <Divider style={{ marginBottom: "20px" }} />
                                  </>
                                );
                              }
                            )
                          : null}
                        <AddCircleIcon
                          type="submit"
                          onClick={() => handleChild(true, 0, index)}
                          fontSize="large"
                          color="primary"
                          style={{ cursor: "pointer" }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </div>
          );
        })}
        <AddCircleIcon
          type="submit"
          onClick={() => handleClientAction(true, 0)}
          fontSize="large"
          color="primary"
          style={{ cursor: "pointer" }}
        />
      </Grid>
      {dialogState?.isOpen && (
        <AlertDialog
          dialogState={dialogState}
          dialogContent={`Are you sure you want to delete client action list?`}
          handleSubmit={(value) => handleClientAction(false, value?.index)}
          handleClose={() => setDialogState(undefined)}
        />
      )}
      {dialogStateActions?.isOpen && (
        <AlertDialog
          dialogState={dialogStateActions}
          dialogContent={`Are you sure you want to delete this follow up schedule?`}
          handleSubmit={(value) =>
            handleChild(false, value?.childIndex, value?.index)
          }
          handleClose={() => setDialogStateActions(undefined)}
        />
      )}
    </Grid>
  );
};
